import {Divider, FormLabel} from '@mui/material';
import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Grid from '@mui/material/Grid';
import {useStylesECDS} from './ecdsStyle';
import config from '../../../../app/config';
import AgyleTextField from '../../../../components/ui/fields/agyleTextField';
import clsx from 'clsx';
import {cleanObject} from '../../../../util/patientContextUtil';

const DiseaseOutbreak = (props) => {
    const {t} = useTranslation();
    const classes = useStylesECDS();

    // Disease Outbreak Dataset
    const [disease, setDisease] = useState({
        ClinicalTrialIdentifier: '',
        DiseaseOutBreakNotificationDescription: '',
        DiseaseOutBreakNotificationSnomedCt: '',
    });

    // Validation
    const validationEnabled = config?.modules?.forms?.ecds?.validation || false;
    const [error, setError] = useState({
        trialId: false,
        notification: false,
        description: false,
    });

    // For ReadOnly Data
    const disableData = useRef({});

    // Initial Data
    useEffect(() => {
        let data = {};
        let dataToBlock = {};

        if (props.patient?.studies?.diseaseOutbreak) {
            data = {
                ClinicalTrialIdentifier: props.patient?.studies?.diseaseOutbreak.ClinicalTrialIdentifier,
                DiseaseOutBreakNotificationDescription: props.patient?.studies?.diseaseOutbreak.DiseaseOutBreakNotificationDescription,
                DiseaseOutBreakNotificationSnomedCt: props.patient?.studies?.diseaseOutbreak.DiseaseOutBreakNotificationSnomedCt,
            };
        }

        if (props.patient?.studies?.EmergencyCare?.AttendanceOccurrence?.ResearchAndDiseaseOutbreakNotification) {
            data = {
                ...props.patient?.studies?.EmergencyCare?.AttendanceOccurrence?.ResearchAndDiseaseOutbreakNotification,
            };
        }
        setDisease(prevState => ({...prevState, ...data}));
        disableData.current = {...cleanObject(dataToBlock)};
    }, []);

    const updateData = () => {
        const data = {
            ClinicalTrialIdentifier: disease.ClinicalTrialIdentifier,
            DiseaseOutBreakNotificationDescription: disease.DiseaseOutBreakNotificationDescription,
            DiseaseOutBreakNotificationSnomedCt: disease.DiseaseOutBreakNotificationSnomedCt,
        };
        props.setData(data);
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (validate()) {
                updateData();
            }
        }, 400);

        return () => clearTimeout(timeoutId);
    }, [disease]);

    const changeHandler = (event) => {
        setDisease((prevState) => ({...prevState, [event.target.name]: event.target.value}));
    };

    const validate = () => {
        let check = true;

        if (validationEnabled) {
            const errorData = {
                description: disease.DiseaseOutBreakNotificationDescription ? !props.checkLenght(0, 20, disease.DiseaseOutBreakNotificationDescription) : false,
                notification: disease.DiseaseOutBreakNotificationSnomedCt ? !props.checkLenght(6, 18, disease.DiseaseOutBreakNotificationSnomedCt) : false,
                trialId: disease.ClinicalTrialIdentifier ? !props.checkLenght(0, 20, disease.ClinicalTrialIdentifier) : false,
            };

            setError(prevState => ({...prevState, ...errorData}));

            for (let prop in errorData) {
                if (errorData[prop]) {
                    check = false;
                    break;
                }
            }

            if (props.valid) {
                const validObj = {
                    name: 'Research and Disease Outbreak Notification',
                    groupStatus: 'O',
                    mandatory: false,
                    errors: !check,
                    pickers: false,
                };
                props.valid(prevState => ({...prevState, 'disease': validObj}));
            }
        }
        return check;
    };

    return (
        <div className={classes.root}>
            <Grid item xs={12}>
                <AgyleTextField
                    name="ClinicalTrialIdentifier"
                    label={t('Clinical Trial Identifier')}
                    value={disease.ClinicalTrialIdentifier || ''}
                    onChange={changeHandler}
                    error={error.trialId}
                    helperText={error.trialId ? 'Input must be max 20 characters long.' : ''}
                    disabled={props.disabled}
                    maxLength={20}
                    readOnly={!!disableData?.current.ClinicalTrialIdentifier}
                    fullWidth
                    debounce
                    noBorder={false}
                    withNewBackground
                    size="large"
                />
            </Grid>

            <div style={{margin: '10px 0'}}>
                <FormLabel className={clsx(classes.label, 'small')}>
                    {t('Choose only one option group')}
                </FormLabel>
            </div>

            <Grid item xs={12}>
                <AgyleTextField
                    name="DiseaseOutBreakNotificationDescription"
                    label={t('Disease Outbreak Description')}
                    value={disease.DiseaseOutBreakNotificationDescription || ''}
                    onChange={changeHandler}
                    error={error.description}
                    helperText={error.description ? 'Input must be max 20 characters long.' : ''}
                    disabled={!!disease.DiseaseOutBreakNotificationSnomedCt || props.disabled}
                    maxLength={20}
                    readOnly={!!disableData?.current.DiseaseOutBreakNotificationDescription}
                    fullWidth
                    debounce
                    noBorder={false}
                    withNewBackground
                    size="large"
                />
            </Grid>

            <Divider sx={{m: 1}}/>

            <Grid item xs={12}>
                <AgyleTextField
                    name="DiseaseOutBreakNotificationSnomedCt"
                    label={t('Disease Outbreak Notification')}
                    value={disease.DiseaseOutBreakNotificationSnomedCt || ''}
                    onChange={changeHandler}
                    error={error.notification}
                    helperText={error.notification ? 'Input must be between 6 and 18 characters long.' : ''}
                    disabled={!!disease.DiseaseOutBreakNotificationDescription || props.disabled}
                    type="number"
                    readOnly={!!disableData?.current.DiseaseOutBreakNotificationSnomedCt}
                    fullWidth
                    debounce
                    noBorder={false}
                    withNewBackground
                    size="large"
                />
            </Grid>
        </div>
    );
};

export default DiseaseOutbreak;
